module.exports = require('./helpers/bundle-url').getBundleURL('hzsxP') + "logo.c51670a8.svg";